import React from 'react';

import momentZ from 'moment-timezone';
import {Metric} from '../../models/Metric';
import ImageWithFallback from '../general/ImageWithFallback';

interface StateProps {
    metric: Metric,
    arrayIndex: number
}
export const MetricView = (({metric, arrayIndex}: StateProps) => {

    const renderCover = () => {
        return <div className={'metric-cover-container'}>
            <ImageWithFallback
                 className={'metric-cover'}
                 src={metric.cover}
                 fallback={require('../../resources/imgs/def-cover.png')}
            />
        </div>
    }

    return <div className={'reels-items-container-none-height'}>
        <div className={'metric-item'}>
            <div className={'metrics-id-column item-right-border'} style={{position: 'relative'}}>
                <div style={{display: 'flex', position: 'absolute'}}>
                    {arrayIndex}
                </div>
            </div>
            <div className={'metrics-cover-column item-right-border'}>{renderCover()}</div>
            <div className={'metrics-name-column item-right-border'}>{metric.name}</div>
            <div className={'metrics-is-free-column item-right-border'}>{metric.isFree ? 'Free' : 'Paid'}</div>
            <div className={'metrics-date-column item-right-border'}>{momentZ(metric.createdAt).format('YYYY-MM-DD HH:mm')}</div>
            <div className={'metrics-views-column item-right-border'}>{metric.viewsCount}</div>
            <div className={'metrics-exports-column item-right-border'}>{metric.exportsCount}</div>
            <div className={'metrics-ratio-column item-right-border'}>{metric.exportToViewRatio}</div>
            <div className={'metrics-popularity-column'}>{metric.popularity}</div>
        </div>
    </div>
});
